import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-scroll';

const pages = [
  { title: 'Home', path: 'home' },
  { title: 'About', path: 'about' },
  { title: 'Tour', path: 'tour' },
  { title: 'Merch', path: 'merch' },
  { title: 'Music', path: 'music' },
];

const Navbar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);
  const offsetValue = isMobile ? -36 : -48;

  const drawerContent = (
    <List sx={{ width: 200, paddingTop: 2 }}>
      {pages.map((page) => (
        <ListItem key={page.title} disablePadding>
          <ListItemButton
            onClick={() => setDrawerOpen(false)}
            sx={{ textAlign: 'left' }}
          >
            {/* React Scroll Link */}
            <Link
              to={page.path}
              smooth={true}
              duration={500}
              offset={offsetValue}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <ListItemText
                primary={page.title.toUpperCase()}
                primaryTypographyProps={{
                  fontSize: '1rem',
                }}
              />
            </Link>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );

  return (
    <AppBar
      position="sticky"
      sx={{
        width: '100%',
        margin: 0,
        padding: 0,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          // Optional: add some horizontal padding if you like
          px: 2,
        }}
      >
        {isMobile ? (
          <>
            <IconButton
              color="inherit"
              onClick={handleDrawerToggle}
              sx={{ ml: 'auto' }} // push icon to the right
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={handleDrawerToggle}
              variant="temporary"
              ModalProps={{
                keepMounted: true,
                // This prevents iOS Safari from shifting the background
                disableScrollLock: true,
              }}
              sx={{
                '& .MuiDrawer-paper': {
                  backgroundColor: theme.palette.primary.dark,
                  color: '#fff',
                  width: 200, // fixed width
                },
              }}
            >
              {drawerContent}
            </Drawer>
          </>
        ) : (
          pages.map((page) => (
            <Button
              key={page.title}
              color="inherit"
              sx={{ textTransform: 'uppercase', ml: 2 }}
            >
              <Link
                to={page.path}
                smooth
                duration={500}
                offset={offsetValue}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {page.title}
              </Link>
            </Button>
          ))
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
